import React from 'react';
import { LotCalcule, StatutTS, SituationSousTraitant } from '../types';
import LotRow from './LotRow';

interface LotTableProps {
  lots: LotCalcule[];
  onAjouterSituation: (lotId: string) => void;
  onAjouterTS: (lotId: string, ts: {
    intitule: string;
    montant: number;
    commentaire?: string;
    dateAjout: string;
    statut: StatutTS;
  }) => void;
  onAjouterSituationST?: (lotId: string, situation: Omit<SituationSousTraitant, 'id'>) => void;
}

const LotTable: React.FC<LotTableProps> = ({ lots, onAjouterSituation, onAjouterTS, onAjouterSituationST }) => {
  return (
    <section className="p-6 bg-white shadow rounded-xl mb-8">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Lots du projet</h2>
      <div className="space-y-3">
        {lots.map(lot => (
          <LotRow
            key={lot.id}
            lot={lot}
            onAjouterSituation={onAjouterSituation}
            onAjouterTS={onAjouterTS}
            onAjouterSituationST={onAjouterSituationST}
          />
        ))}
      </div>
    </section>
  );
};

export default LotTable;
